import React from "react";

const About = () => {
  return (
   <>
      <div class="section" id="why-us">
      <div class="container flex">
      <div class="visual">
          <img
            src="https://i.imgur.com/IHrr7XF.png"
            alt=""
          />
        </div>
        <div class="text">
          <h2 class="primary mb">About  Us</h2>
          {/* <h3 class="secondary mb">Lorem, ipsum dolor sit amet.</h3> */}
          <p class="tertiary">
          Wortheweight, founded by certified and qualified trainers, offers comprehensive resources and expert advice for individuals seeking to improve their physical health. They believe in the transformative power of physical training, providing coaching services, meal plans, training programs, and 24/7 guidance to help individuals achieve peak physical health, strength, and appearance.
          </p>

      
        </div>
       
      </div>
    </div>
   </>
  );
};

export default About;
